export default __webpack_public_path__ + "static/media/F9.646b7d26.svg";